import { User } from "types/user";
import { RegistrationFormikValues } from "constants/registration";
import { trendFetch } from "api";

type CreatorApplication = RegistrationFormikValues & {
  user: Required<Pick<User, "email" | "_id">>;
};

export const postCreatorApplication = (application: CreatorApplication) => {
  const arrayCategoryApp = {
    ...application,
    socialCategories: Object.keys(application.creatorCategories),
    contentCategories: Object.keys(application.creatorSkills),
  };

  return trendFetch("/creator/registration", {
    method: "POST",
    body: JSON.stringify(arrayCategoryApp),
  }).then((res) => {
    if (!res.ok) {
      throw new Error(res.statusText || "Submission Error");
    }
    return res.json();
  });
};
